<template>
  <div class="card" id="Card" style="direction: rtl">
    <div class="card-header">
      <h3 class="card-title">کارت</h3>
    </div>
    <div class="card-body">
      <CRow style="color: white">
        <CCol>
          <CInput label="تعداد:" v-model="info.card_count"/>
        </CCol>
        <CCol>
          <CInput label="موجودی:" v-model="info.init_balance" />
        </CCol>
        <CCol>
          <label >از تاریخ</label>
          <date-picker  id="stTime" v-model="formDate" aria-label="از تاریخ" type="date"></date-picker>
        </CCol>
        <CCol>
          <label >تا تاریخ</label>
          <date-picker  id="ftTime" v-model="toDate" aria-label="تا تاریخ" type="date"></date-picker>
        </CCol>
      </CRow>
      <br>
      <CRow style="color: white">
        <CCol>

        </CCol>
         <CCol>

        </CCol>
         <CCol>

        </CCol>
         <CCol>
           <CButton style="float: left" color="primary" @click="GenerateCart()">&nbsp;&nbsp;  تولید کارت</CButton>
        </CCol>

      </CRow>
      <CDataTable
          :hover="true"
          :border="true"
          
          :striped="true"
          :loading="loading"
          :small="true"
          :items="json_data"
          :fields="fieldObject"
          :fixed="true"
          :items-per-page="10"
          pagination
          style="float: right;width: 100%;overflow: hidden;margin-top: 20px;direction: rtl;"
          :noItemsView="{ noResults: 'چیزی یافت نشد.', noItems: 'چیزی برای نمایش وجود ندارد.' }"

      >
<!--        <template #Person="{item}">
          <td>
            {{item.person.per_name+' '+  item.person.per_last_name}}
          </td>
        </template>
        <template #type="{item}">
          <td>
            {{item.type.mrf_title}}
          </td>
        </template>-->
      </CDataTable>
      <!--    <CPagination
              size="lg"
              style="float: right;width: 100%;overflow: hidden;margin-top: 20px;direction: rtl;"
              @update:activePage="Change"
              v-if="Carts.last_page>1"
              :active-page.sync="currentPage"
              :pages="Carts.last_page"/>-->

    </div>
    <div class="card-footer">

    </div>
  </div>
</template>

<script>
import Constant from "../../assets/Constants";
import Vue from "vue";
export default {
  name: "Cart",
  data(){
    return {
      filter:false,
      info:{
        card_count:20,
        init_balance:5000,
        expire_date:'',
        effective_date:'',
        currency_id:1,
      },
      Carts:[],
      formDate:'',
      toDate:'',
      Filter:{
        ID:"",
        Ref:"",
        Amount:"",
        Balance:"",
        CartID:"",
        AccountID:"",
        TerminalID:"",
        MerchantID:"",
      },
      loading:false,
      fieldObject:[{key:'id',label:'شناسه'},{key:'effective_date',label:'تاریخ'},{key:'expire_date',label:'تاریخ انقضا'},{key:'pan',label:'pan'},{key:'state',label:'وضعیت'},{key:'title',label:'عنوان'}],
      currentPage:1,

      json_fields: {
        "effective_date": "effective_date",
        expire_date: "expire_date",
        id: "id",
        issuance_date: "issuance_date",
        pan: 'pan',
        state: "state",
        title: "title",
        type: "type",
      },
      json_data: [],
      json_meta: [
        [
          {
            key: "pan",
            value: "string",
          },
        ],
      ],

    }
  },
  mounted() {
   // this.GetCart(1,10);
    this.InitDate();
  },
  methods: {
    InitDate(){
      var timeNow=Vue.moment().format('YYYY-MM-DD HH:mm:ss');
      var timefrom=Vue.moment().add(2,'year').format('YYYY-MM-DD HH:mm:ss');
      console.log(timeNow);
      this.formDate=Vue.moment(timeNow, "YYYY-MM-DD HH:mm:ss").format("jYYYY-jMM-jDD HH:mm:ss");
      this.toDate=Vue.moment(timefrom, "YYYY-MM-DD HH:mm:ss").format("jYYYY-jMM-jDD HH:mm:ss");
    },
    GenerateCart() {
      var from=Vue.moment(this.formDate, "jYYYY-jMM-jDD").format("YYYY-MM-DD");
      var to=Vue.moment(this.toDate, "jYYYY-jMM-jDD").format("YYYY-MM-DD");
      this.loading = true;

      var that = this;
      this.axios
          .post("http://85.15.46.129:10354/cms-1.0-SNAPSHOT/rest/api/cards",{
            card_count:this.info.card_count,
            currency_id:this.info.currency_id,
            init_balance:this.info.init_balance,
            effective_date:from,
            expire_date:to,
          })
          .then(response => {
            that.Loading = false
            var data = response.data;
            this.json_data = data;

          }).catch(function (error) {
        console.log(error);
      })
          .finally(() => {
            that.loading = false;

          });
    },
    Change(val, val2) {
      console.log("OK --> ", val, val2);
      if (this.filter) {
        this.GetTransactionFilter(val, 10);
      } else {
        this.GetCart(val, 10);
      }

    }
  }
}
</script>

<style scoped>

</style>